/**
 * @param {*} value
 * @returns {value is Date}
 */
export function isDate(value) {
  return value instanceof Date;
}
